import * as React from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import Router from "../../Router";
import ScrollToTop from "./RouteToTop";
import BackToTop from "react-back-to-top";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { usesPlatformChrome } from "./platform/pageChrome";
import PlatformShell from "./platform/PlatformShell";
import { marketingColors } from "./tickitMarketingTheme";

function FullPageLayout({ role }) {
  const { pathname } = useLocation();
  const platformMode = usesPlatformChrome(pathname, role);

  return (
    <div className={platformMode ? "fullPage fullPage--platform" : "fullPage fullPage--marketing"}>
      <a href="#main-content" className="skip-to-main">
        Skip to main content
      </a>
      <PlatformShell>
        <Router />
      </PlatformShell>
      <ScrollToTop />
      <BackToTop
        mainStyle={{
          "border-radius": 30,
          "background-color": marketingColors.p700,
        }}
        children={<KeyboardArrowUpIcon sx={{ color: "#fff" }} />}
        isPercent={false}
        offsetTop={0}
        step={50}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  role: state?.auth?.token?.split(" ")[0],
});

export default connect(mapStateToProps)(FullPageLayout);
